import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './ZendeskWidget.css';

const ZendeskWidget = ({ allowedRoutes = [] }) => {
  const location = useLocation();
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    // For now, we'll always show the widget
    // const currentPath = location.pathname;

    // const isAllowed = allowedRoutes.some(route => {
    //   if (route.includes(":")) {
    //     const routeParts = route.split("/");
    //     const pathParts = currentPath.split("/");

    //     if (routeParts.length !== pathParts.length) return false;

    //     return routeParts.every((part, index) => {
    //       return part.startsWith(":") || part === pathParts[index];
    //     });
    //   }
    //   return route === currentPath;
    // });

    if (!isScriptLoaded) {
      const script = document.createElement('script');
      script.id = 'ze-snippet';
      script.src = process.env.REACT_APP_ZENDESK_SRC || '';
      script.async = true;

      script.onload = () => {
        setIsScriptLoaded(true);
      };

      document.head.appendChild(script);
    }

    // const hideWidget = () => {
    //   // Zendesk launcher button has id "launcher"
    //   const elements = document.querySelectorAll("#launcher");
    //   elements.forEach(element => {
    //     if (!isAllowed) {
    //       element.classList.add("zendesk-hidden");
    //     } else {
    //       element.classList.remove("zendesk-hidden");
    //     }
    //   });
    // };

    if (isScriptLoaded) {
      // hideWidget();
    }
  }, [location.pathname, allowedRoutes, isScriptLoaded]);

  return null;
};

export default ZendeskWidget;
